import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { System, RTEAlertService } from 'rte-library';
import { IMenuService, Menu } from 'rte-core-app';


@Injectable({
  providedIn: 'root'
})
export class MenuService implements IMenuService {

  headers = new HttpHeaders({
    'No-loading': 'True'
  });

  constructor(
    private http: HttpClient,
    private alert: RTEAlertService
  ) { }

  getMenus(): Observable<Menu[]> {
    return this.http.get<Menu[]>(environment.apiUrl + 'api/user/getmenubyuser?systemId=' + environment.systemId)
      .pipe(catchError(this.handleError<Menu[]>('getMenus',[]))
      );
  }

  getLogo(): Observable<string> {
    return this.http.get<string>(environment.apiUrl + 'api/company/Logo')
      .pipe(catchError(this.handleError<string>('getLogo'))
      );
  }

  getSystem(): Observable<System> {
    return this.http.get<System>(environment.apiUrl + 'api/system/getbyid?Id=' + environment.systemId)
      .pipe(catchError(this.handleError<System>('getbyid'))
      );
  }

  getTreeMenus(): Observable<Menu[]> {
    return this.http.get<Menu[]>(environment.apiUrl + 'api/user/getmenutreebyuser?systemId=' + environment.systemId)
      .pipe(catchError(this.handleError<Menu[]>('getTreeMenus', []))
      );
  }

  getLocalMenus(): Menu[] {
    var menu: Menu[] = [];
    menu['{icon:bubble_chart} Portal de Relatórios ']= {
      'Administração': {
        'Cadastro de provedores': '/provedor',
        'Cadastro de entidades': '/entidade',
        'Cadastro de relatórios': '/relatorio'
      }
    };
    return menu;
  }

  deleteMenuByObjectId(objectId: number) {
    const params = new HttpParams()
                    .set('id', objectId.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/menureport',  { headers: this.headers, params });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.Message !== undefined) {
        this.alert.error('' + error.error.Message);
      }
      else {
        this.alert.error('Não foi possível concluir a solicitação.');
      }
      return of(result as T);
    };
  }
}
